/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import { Directive, ElementRef, HostListener } from '@angular/core'
import { NgControl } from '@angular/forms'

@Directive({
  selector: '[appPhoneMask]',
})
export class PhoneMaskDirective {
  constructor(public ngControl: NgControl, public el: ElementRef) {}

  @HostListener('ngModelChange', ['$event'])
  onModelChange(event) {
    this.onInputChange(event, false)
  }

  @HostListener('keydown.backspace', ['$event'])
  keydownBackspace(event) {
    this.onInputChange(event.target.value, true)
  }

  onInputChange(event, backspace) {
    if (event == null) {
      return
    }
    let newVal = event.replace(/\D/g, '')
    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1)
    }

    if (newVal.length === 0) {
      newVal = ''
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)')
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2')
    } else {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3')
    }

    if (newVal === '') {
      this.ngControl.control.setValue(null)
    } 
    else if(newVal.length === 14
            && newVal != this.ngControl.control.value){
      this.ngControl.control.setValue(newVal)
    }
    else {
      this.ngControl.valueAccessor.writeValue(newVal)

    
    }
  }
}
